











import { Component, Vue } from 'vue-property-decorator';
import PaymentForm from './components/paymentForm.vue';
import { paymentListInstance } from '@/model/PaymentListClass';
import { CLOSE_TAG_VIEW_EVENT, pubsub } from '@/utils/pubsub';

type IUpdatePaymentData = IPayment.IRequest.IUpdatePaymentData;

@Component({
  components: {
    PaymentForm,
  },
})
export default class UpdatePayment extends Vue {
  private paymentListInstance = paymentListInstance;
  get paymentInfoForEdit(): IUpdatePaymentData {
    return {
      title: this.payment?.title || '',
      items: this.payment?.items || [],
      type: this.payment?.type || 0,
      jsonData: this.payment?.jsonData || '',
    };
  }
  get payment() {
    return this.paymentListInstance.editItem;
  }
  private changePayment(payment: IUpdatePaymentData): Promise<string> {
    return new Promise((reslove, reject) => {
      if (!this.payment) {
        reject('Error');
        return;
      }
      this.paymentListInstance.requestChangeItem(this.payment, payment).then((res) => {
        reslove(res);
        this.goListPage();
      }).catch((err) => {
        reject(err);
      });
    });
  }
  private goListPage() {
    pubsub.publish(CLOSE_TAG_VIEW_EVENT, this.$route.path);
    this.$router.push({
      name: 'Payment',
    });
  }
}
